import { GroupDividerLayout } from '@/components/table/group-divider-layout';
import { SchoolNameGroupKey } from '@/lib/table-grouping-utils';

interface SchoolNameDividerProps {
  groupKey: SchoolNameGroupKey;
  rowCount: number;
}

export function SchoolNameDivider({ groupKey, rowCount }: SchoolNameDividerProps) {
  return <GroupDividerLayout rowCount={rowCount}>{groupKey.schoolName}</GroupDividerLayout>;
}
